import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import EditEducationDetailsPage from '@/features/account/profile/edit-education-details';
import { HomeGate } from '@/features/account/shell/HomeGate';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

const paramsSchema = z.object({ id: z.string().uuid() });

export const Route = createFileRoute('/perfil/editar/formacoes/$id')({
  params: {
    parse: (raw) => paramsSchema.parse(raw),
    stringify: ({ id }) => ({ id: String(id) }),
  },
  component: () => (
    <HomeGate>
      <EditEducationDetailsPage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
